import * as React from 'react'

export default (props) =>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.085" height="11.2" viewBox="0 0 13.085 11.2" {...props}>
    <path id="Path_32789" data-name="Path 32789" d="M-3487.965-12566.826l4.192,4.148,7.485-10" transform="translate(3488.672 12573.378)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
  </svg>
